<div class="filter">
    <label
        class="filter__title"
        [htmlFor]="filter.key"
    >
        {{ filter.title }}
    </label>

    <span class="filter__input">
        <i class="pi pi-search"></i>
        <input
            type="text"
            pInputText
            [id]="filter.key"
            [attr.aria-label]="filter.title"
            [ngModel]="value$ | async"
            [placeholder]="placeholder"
            (ngModelChange)="onTextChange($event)"
        >
    </span>
</div>
